export default import.meta.ROLLDOWN_FILE_URL_bG2Z5F54O5TFNy8YdDQQiw